import React, { useMemo } from 'react';
import { Spinner } from 'reactstrap';
import OBarChart from '../../../../Components/OElements/OBarChart';
import { generateColorGradient } from '../../../../Components/Hooks/useColorArrayHooks';

const InspectionsByYearCenterAuthorityChart = ({ data, isLoading }) => {
	const years = Array.isArray(data?.years) ? data.years : [];
	const series = Array.isArray(data?.series) ? data.series : [];

	const options = useMemo(() => {
		return {
			color: generateColorGradient(series.length || 1),
			tooltip: {
				trigger: 'axis',
				axisPointer: { type: 'shadow' },
			},
			legend: {
				bottom: 0,
				type: 'scroll',
			},
			grid: {
				left: '3%',
				right: '4%',
				top: '10%',
				bottom: '15%',
				containLabel: true,
			},
			xAxis: {
				type: 'category',
				data: years.map(y => String(y)),
			},
			yAxis: {
				type: 'value',
				name: 'Fiscalizaciones',
			},
			series: series.map(item => ({
				name: item?.name || 'Sin entidad',
				type: 'bar',
				data: Array.isArray(item?.data) ? item.data : [],
				barMaxWidth: 40,
				emphasis: { focus: 'series' },
				label: {
					show: true,
					position: 'top',
					formatter: ({ value }) => (value > 0 ? value : ''),
				},
			})),
		};
	}, [years, series]);

	if (isLoading) {
		return (
			<div className='d-flex justify-content-center align-items-center py-4'>
				<Spinner size='sm' />
			</div>
		);
	}

	if (!years.length || !series.length) {
		return (
			<div className='d-flex flex-column align-items-center justify-content-center text-muted py-4 h-100'>
				<i className='ri-bar-chart-grouped-line fs-1 mb-2'></i>
				<p className='mb-0'>Sin datos disponibles</p>
			</div>
		);
	}

	return <OBarChart options={options} minHeight='320px' style={{ height: '100%' }} />;
};

export default React.memo(InspectionsByYearCenterAuthorityChart);